import styled from 'styled-components';
import { P } from 'components/Typography';
import { TextArea as _TextArea } from 'components/Inputs';
import { th } from 'style/theme';
import { sizes } from 'style';

export const SubTitle = styled(P)`
  margin: 12px 0 22px 0;
`;

export const Buttons = styled.div`
  margin-top: 20px;
  > :first-child {
    margin-right: 16px;
  }
`;

export const PreExExplanation = styled.div`
  margin-top: 22px;
  font-size: 14px;
`;

export const PreExDescription = styled.div`
  margin-top: 20px;
`;

export const DescriptionContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;

  @media ${sizes.tabletPortrait} {
    flex-direction: row-reverse;
    gap: 20px;
  }
`;

export const Tips = styled.div`
  padding: 12px;
  border-radius: 5px;
  background-color: ${th('colors.aliceBlue')};

  @media ${sizes.tabletPortrait} {
    width: 230px;
  }

  @media ${sizes.mediumLargeDesktop} {
    position: absolute;
    right: -250px;
  }

  > ul {
    padding-left: 0;
    margin-top: 4px;
    margin-bottom: 0;
    font-size: 14px;
    color: #4c6372bf;

    > li {
      margin: 5px 0 0 20px;
    }
  }
`;

export const TextArea = styled(_TextArea)`
  > textarea {
    height: 200px;
    margin-top: 1px;

    @media ${sizes.tabletPortrait} {
      height: 100%;
    }

    @media ${sizes.mediumLargeDesktop} {
      height: 186px;
    }
  }

  @media ${sizes.tabletPortrait} {
    flex: 1;
  }
`;
